module.exports = __webpack_public_path__ + "static/media/search-icon.41f17433.svg";